import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from '@spothero/ui/button';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import FormGroup from '@spothero/ui/form-group';
import Label from '@spothero/ui/label';
import TextButton from '@spothero/ui/text-button';
import TextInput from '@spothero/ui/text-input';
import StripeCreditCardElement from './StripeCreditCardElement';
import PaymentMethodsIcons from 'common/payment-methods-icons/PaymentMethodsIcons';

export default class AddNewCardForm extends Component {
    static propTypes = {
        showTitle: PropTypes.bool,
        showCTAs: PropTypes.bool,
        onNevermindClick: PropTypes.func,
        onAddCardClick: PropTypes.func,
    };
    state = {
        areActionsDisabled: false,
    };

    submit() {
        return this._newCreditCard.submit();
    }

    render() {
        const {
            showTitle,
            showCTAs,
            onAddCardClick,
            onNevermindClick,
        } = this.props;
        const {areActionsDisabled} = this.state;

        return (
            <div className="AddNewCardForm">
                {showTitle && <h2 className="subtitle">Add a Credit Card</h2>}
                <PaymentMethodsIcons showLesserUsed />
                <Form
                    ref={node => {
                        this._newCreditCard = node;
                    }}
                    id="AddNewCardForm-form"
                >
                    <FormGroup>
                        <StripeCreditCardElement />
                    </FormGroup>
                    <FormGroup>
                        <TextInput
                            name="fullName"
                            label={<Label>Name on Card</Label>}
                            error={
                                <FormElementError>
                                    Please enter the full name on the card.
                                </FormElementError>
                            }
                            required
                        />
                    </FormGroup>
                    {showCTAs && (
                        <div className="FormActions">
                            <Button
                                type="submit"
                                color="primary"
                                disabled={areActionsDisabled}
                                loading={areActionsDisabled}
                                onClick={onAddCardClick}
                            >
                                Add Card
                            </Button>
                            <TextButton
                                disabled={areActionsDisabled}
                                onClick={onNevermindClick}
                            >
                                Nevermind
                            </TextButton>
                        </div>
                    )}
                </Form>
            </div>
        );
    }
}
